import { Link } from 'react-router-dom';
import PageLayout from '../components/feature/PageLayout';

export default function NotFound() {
  return (
    <PageLayout>
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24 pb-16">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/0af11b8474c7020b7aec71dc7b57c6e2.jpg"
            alt="Background"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-navy/85 via-navy/75 to-navy/85"></div>
        </div>

        <div className="relative z-10 max-w-3xl mx-auto px-6 text-center w-full">
          {/* Large decorative 404 */}
          <div className="relative mb-4 select-none pointer-events-none">
            <span className="text-[10rem] md:text-[14rem] font-black leading-none text-white/5 block">
              404
            </span>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-[6rem] md:text-[9rem] font-black leading-none text-gold/20 block">
                404
              </span>
            </div>
          </div>

          {/* Icon */}
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-gold/10 border border-gold/30 rounded-full">
            <i className="ri-compass-discover-line text-gold text-2xl"></i>
          </div>

          {/* Badge */}
          <div className="inline-block mb-5 px-4 py-1.5 bg-gold/10 border border-gold/20 rounded-md">
            <span className="text-gold text-sm font-semibold tracking-wide uppercase">Page Not Found</span>
          </div>

          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
            Looks Like You've Wandered<br />
            <span className="text-gold">Off the Map</span>
          </h1>

          <p className="text-white/60 text-base md:text-lg mb-10 max-w-xl mx-auto leading-relaxed">
            The page you're looking for doesn't exist or may have been moved. Let's get you back on track.
          </p>

          {/* Action buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-14">
            <Link
              to="/"
              className="px-8 py-3.5 bg-gold text-white font-semibold rounded-full hover:bg-[#a68a4e] transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line mr-2"></i>
              Back to Home
            </Link>
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-full hover:bg-white/20 transition-all border border-white/30 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              Contact Us
            </Link>
          </div>

          {/* Quick links */}
          <div className="border-t border-white/10 pt-10">
            <p className="text-white/40 text-sm mb-6 uppercase tracking-widest font-medium">Or explore these pages</p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-2xl mx-auto">
              {[
                { label: 'About Us', path: '/about', icon: 'ri-team-line' },
                { label: 'Services', path: '/services', icon: 'ri-briefcase-line' },
                { label: 'Service Areas', path: '/service-areas', icon: 'ri-map-pin-line' },
                { label: 'FAQs', path: '/faqs', icon: 'ri-question-answer-line' },
              ].map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="flex flex-col items-center gap-2 px-4 py-4 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-gold/30 rounded-lg transition-all cursor-pointer group"
                >
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${item.icon} text-gold text-lg group-hover:scale-110 transition-transform`}></i>
                  </div>
                  <span className="text-white/70 group-hover:text-white text-xs font-medium transition-colors whitespace-nowrap">
                    {item.label}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
